import DataManage from './DataManage'

export default DataManage;